import { forwardRef } from 'react';
import { createUseTextLocalizer } from '../../locale/createUseTextLocalizer';
import { useFormatter } from '../../locale/formatting';
import { Button, ButtonVariant } from '../Button';
import bundle from './NovaComponents-ObjectManager-gui-icu.properties';
import { jsx as _jsx } from "react/jsx-runtime";
const useTextLocalizer = createUseTextLocalizer(bundle);

/**
 * Wrapper around the button that launches the ObjectSwitcher
 */
export const ObjectSwitcherLaunchButton = /*#__PURE__*/forwardRef(function ObjectSwitcherLaunchButton(props, forwardedRef) {
  const localize = useTextLocalizer();
  const formatter = useFormatter();
  const numberOfObjects = formatter?.formatNumeric(props.numberOfObjects);
  let openedItemsText = '';
  if (props.numberOfObjects === 0) {
    openedItemsText = localize('objectManager.objectSwitcher.openedItems.button.label');
  } else {
    openedItemsText = localize('objectManager.objectSwitcher.openedItems.withCount.button.label', {
      count: `(${numberOfObjects})`
    });
  }
  return /*#__PURE__*/_jsx(Button, {
    ref: forwardedRef,
    text: openedItemsText,
    testId: props.testId,
    variant: ButtonVariant.Light,
    focusable: props.focusable,
    disabled: props.disabled ?? props.numberOfObjects === 0,
    onPress: props.onPress,
    theme: (dt, {
      disabled
    }) => {
      if (disabled) {
        return {
          '--button-fg': dt.tokens['color-action-text-subtle-disabled'],
          '--button-hover-fg': dt.tokens['color-action-text-subtle-disabled'],
          '--button-active-fg': dt.tokens['color-action-text-subtle-disabled']
        };
      }
      return {
        '--button-fg': dt.tokens['color-text-primary'],
        '--button-hover-fg': dt.tokens['color-action-text-subtle-hover'],
        '--button-active-fg': dt.tokens['color-action-text-subtle-selected']
      };
    }
  });
});
//# sourceMappingURL=ObjectSwitcherLaunchButton.js.map